import Vue from "vue";
import axios from "axios";
Vue.prototype.$axios = axios;
axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;
axios.defaults.baseURL = process.env.BASE_API_URL;
axios.get(process.env.BASE_URL + "/sanctum/csrf-cookie").catch(function () {
  console.warn("Could not fetch CSRF cookie. Check BASE_URL configuration.");
});